import SelectField from "@/components/common/fields/SelectField"
import { useEffect } from "react"
import { useField } from "formik"

const CustomFieldQueueSelector = ({ options, defaultValue, index, name }) => {
  const [field, _meta, helpers] = useField({ name: name })

  useEffect(() => {
    if (field?.value === undefined || !field?.value) {
      helpers.setValue(defaultValue)
    }
  }, [field])

  return (
    <SelectField
      key={`queue-selector-select-${index}`}
      name={name}
      fullWidth={true}
      label="Queue"
      options={options}
      value={defaultValue}
    />
  )
}

export default CustomFieldQueueSelector
